/* eslint-disable eag/match-named-export */
import {FlexboxAlign} from '../types/FlexboxAlign';
import {FlexboxDirection} from '../types/FlexboxDirection';
import {FlexboxJustify} from '../types/FlexboxJustify';

export const FLEX_DIRECTION_CLASSES: Record<FlexboxDirection, string> = {
  row: 'flex-row',
  column: 'flex-col',
  'row-reverse': 'flex-row-reverse',
  'column-reverse': 'flex-col-reverse',
};

export const FLEX_ALIGN_CLASSES: Record<FlexboxAlign, string> = {
  'flex-start': 'items-start',
  'flex-end': 'items-end',
  center: 'items-center',
  stretch: 'items-stretch',
  baseline: 'items-baseline',
};

export const FLEX_JUSTIFY_CLASSES: Record<
  Exclude<FlexboxJustify, 'baseline' | 'stretch'>,
  string
> = {
  'flex-start': 'justify-start',
  'flex-end': 'justify-end',
  center: 'justify-center',
  'space-between': 'justify-between',
  'space-around': 'justify-around',
};
